module.exports = __webpack_public_path__ + "static/media/designPic.1.8454fc99.jpg";